(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pudel-prelaunch"] && !Shopify.designMode) return;
  try {
    
function bindPudelWaitlists(){
 document.querySelectorAll('[data-pudel-waitlist]').forEach(form=>{
  if(form.dataset.bound)return;
  form.dataset.bound='true';
  form.addEventListener('submit',async event=>{
   event.preventDefault();
   if(!form.reportValidity()||form.dataset.busy==='true')return;
   const button=form.querySelector('button[type=submit]');
   const status=form.querySelector('[role=status]');
   const emailInput=form.querySelector('input[name="email"]');
   const consentInput=form.querySelector('input[name="consent"]');
   if(!consentInput.checked)return;
   const consentCopy=form.querySelector('.pudel-launch__consent span').textContent.trim();
   const consentVersion=form.dataset.consentVersion;
   const consentProperties={
    pudel_signup_source:'prelaunch_waitlist_2026',
    pudel_consent_copy:consentCopy,
    pudel_consent_at:new Date().toISOString(),
    pudel_consent_version:consentVersion,
    pudel_consent_method:'explicit_checkbox',
    pudel_consent_checkbox_checked:true,
    pudel_consent_channel:'email_marketing',
    pudel_consent_page:window.location.origin+window.location.pathname,
    pudel_consent_privacy_url:new URL('/pages/privacy-policy',window.location.origin).href,
    pudel_consent_locale:document.documentElement.lang
   };
   button.disabled=true;form.dataset.busy='true';status.textContent=form.getAttribute('data-pending');
   try{
    const response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(form.dataset.site),{
     method:'POST',headers:{'Content-Type':'application/vnd.api+json',revision:'2026-01-15'},
     body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Pudel prelaunch waitlist 2026 | '+consentVersion,profile:{data:{type:'profile',attributes:{email:emailInput.value.trim(),properties:consentProperties}}}},relationships:{list:{data:{type:'list',id:form.dataset.list}}}}})
    });
    if(!response.ok)throw new Error('Subscription request failed');
    status.textContent=form.dataset.success;
    emailInput.disabled=true;consentInput.disabled=true;
   }catch(error){status.textContent=form.dataset.error;button.disabled=false;form.dataset.busy='false';}
  });
 });
}
bindPudelWaitlists();
document.addEventListener('shopify:section:load',bindPudelWaitlists);

  } catch(e) { console.error(e); }
})();
})();
